import { ASCII } from "../../components/ASCII";
import { CNN0, CryptidBox } from "./CNN0";
import abd from "url:../../assets/ascii/alientacsii.txt"

export function CNNT () {
    return <div className="v-box gap-32 text-white">
        <CryptidBox header="I Was Abducted">
            <ASCII id='abd' ascii={abd} size={11} />
        </CryptidBox>
    </div>
}